import React, { useEffect } from 'react';
import { useToAccountIdInputLazyQuery } from '../../../../../../../services';
import { RhSingleAutocomplete } from '../../../../../../dum';
import { ITransfer } from '../transfer-form';
import { useTransferType } from '../use-transfer-type';

export function ToAccountInput() {
    const inputName: keyof ITransfer = 'to_account';
    const [query, { data }] = useToAccountIdInputLazyQuery();
    const transferType = useTransferType();

    useEffect(() => {
        if (transferType) {
            void query({
                variables: {
                    isClient: transferType.is_adjustment_transfer,
                    isOwn:
                        transferType.is_own_transfer ||
                        transferType.is_client_transfer ||
                        transferType.is_adjustment_transfer,
                    isSupplier:
                        transferType.is_supplier_transfer ||
                        transferType.is_adjustment_transfer,
                },
            });
        }
    }, [query, transferType]);

    // The "Abono" (credit) account is the supplier's account when we pay a
    // supplier, otherwise one of our own.
    const label = transferType.is_supplier_transfer
        ? 'Abono (cuenta del proveedor)'
        : transferType.is_own_transfer || transferType.is_client_transfer
        ? 'Abono (nuestra cuenta)'
        : 'Abono';

    return (
        <RhSingleAutocomplete
            itemText={'compound_name'}
            itemValue={'id'}
            name={inputName}
            label={label}
            options={data?.getAccounts || []}
            returnObject
        />
    );
}
